export enum MessagingActivityTabs {
  Summary = 'summary',
  Queued = 'queued',
  Messages = 'messages',
  Dcd = 'dcd',
}
